import { useState, useCallback } from 'react';
import { auditService } from '@/services/api';
import type { AuditLog, AuditLogsQueryParams } from '@/common-types';
import type { UseAuditReturn } from '@/types/application/common/hooks/use-audit';

export function useAudit(): UseAuditReturn {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState<string | undefined>(undefined);

  const refresh = useCallback(async (params?: AuditLogsQueryParams) => {
    try {
      setLoading(true);
      setError(null);
      const response = await auditService.getAuditLogs(params);
      
      // If startKey is provided, append logs (load more), otherwise replace (refresh)
      if (params?.startKey) {
        setLogs(prev => [...prev, ...response.logs]);
      } else {
        setLogs(response.logs);
      }
      
      setLastEvaluatedKey(response.lastEvaluatedKey);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load audit logs');
    } finally {
      setLoading(false);
    }
  }, []);

  return { 
    logs, 
    loading, 
    error, 
    refresh,
    hasMore: !!lastEvaluatedKey,
    lastEvaluatedKey
  };
}

export default useAudit;

